import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function GmailSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-subs-gmail-row flex min-h-10 items-center border-b border-[#f1f3f4] bg-white px-4 py-2 text-sm text-[#202124] font-[Roboto,Arial,sans-serif] hover:relative hover:z-[2] hover:shadow-[inset_1px_0_0_#dadce0,inset_-1px_0_0_#dadce0,0_1px_2px_rgba(60,64,67,.3)]${display.isChecked ? ' md-subs-gmail-row--checked bg-[#c2dbff]' : ''}`}>
        <div className="md-subs-gmail-icons flex w-16 flex-none items-center gap-2 [&_.md-sub-icon]:h-[13px] [&_.md-sub-icon]:w-[13px]">
          {controls.actions.check}
          {controls.actions.favorite}
        </div>
        <div className="md-subs-gmail-title min-w-[180px] flex-[0_1_240px] overflow-hidden text-ellipsis whitespace-nowrap font-semibold [&_.md-sub-title-link]:text-[#202124]">
          {controls.content.title}
        </div>
        <div className="md-subs-gmail-text min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#5f6368] [&_.md-sub-text]:inline [&_.md-sub-text]:clear-none [&_.md-sub-text]:text-[#5f6368]">
          {controls.content.text}
        </div>
        <div className="md-subs-gmail-meta ml-3 flex flex-none items-center gap-3 text-xs text-[#5f6368]">
          {controls.content.time}
          {controls.actions.quickReply}
        </div>
      </div>
      <div className="md-subs-gmail-children ml-16">{slots.allChildren}</div>
    </>
  )
}
